var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.593 7.763C17.201 6.388 16 5.201 16 2c0-.284-.121-.554-.331-.744a1.015 1.015 0 0 0-.774-.251C12.51 1.258 8 3.046 8 8c0 .199.008.44.018.709.036 1.04.104 2.976-.505 3.606-.088.091-.218.185-.512.185a.507.507 0 0 1-.422-.187c-.589-.649-.695-2.56-.583-3.709a1 1 0 0 0-1.582-.909 1.012 1.012 0 0 0-.34.429l-.179.431C3.273 10.037 2.5 11.883 2.501 13.5c.003 5.948 3.554 9.5 9.5 9.5 6.126 0 9.5-3.196 9.5-9 0-3.367-1.544-4.892-2.907-6.237zM12 21c-4.834 0-7.498-2.664-7.5-7.5 0-.207.021-.429.058-.66C5.245 14.276 6.367 14.5 7 14.5c.773 0 1.448-.275 1.951-.796 1.198-1.24 1.119-3.542 1.065-5.064C10.008 8.397 10 8.18 10 8c0-3.167 2.558-4.359 4.056-4.785.304 3.178 1.798 4.653 3.132 5.971C18.48 10.461 19.5 11.469 19.5 14c0 4.71-2.453 7-7.5 7z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.aa184c278b09526ed5cf4598a204fa8d.svg";
export { ForwardRef as ReactComponent };